import { FaWifi, FaFileContract } from "@onemind-services-llc/react-icons-ng/fa";
import { Fa6SquareArrowUpRight } from "@onemind-services-llc/react-icons-ng/fa6";
import {
  LuCircleDollarSign,
  LuSlack,
  LuFolderLock,
} from "@onemind-services-llc/react-icons-ng/lu";
import { IoReceiptOutline } from "@onemind-services-llc/react-icons-ng/io5";
import { MdScale } from "@onemind-services-llc/react-icons-ng/md";

export const OMS_FEATURES_COMP = {
  title: "Why Choose OneMind for Your IT Needs? ",
  list: [
    {
      icon: FaWifi,
      title: "Unlimited Cloud Data Transfers ",
      content:
        "Experience seamless data management with free data transfers, transparent pricing, and high-speed, unlimited bandwidth for optimal cloud performance.",
    },
    {
      icon: LuCircleDollarSign,
      title: "Special Partner Pricing",
      content:
        "Get exclusive pricing and cost-effective cloud solutions which are tailored for long-term business success.",
    },
    {
      icon: Fa6SquareArrowUpRight,
      title: "100% Redundancy",
      content:
        "Ensure maximum reliability with fully redundant cloud infrastructure, minimizing downtime and ensuring business continuity.",
    },
    {
      icon: LuFolderLock,
      title: "Highly Secure",
      content:
        "Protect your data with enterprise-grade security, encryption, and compliance-ready infrastructure for ultimate peace of mind.",
    },
    {
      icon: FaFileContract,
      title: "No Long-Term Contracts",
      content:
        "Scale your business without restrictive contracts, giving you flexibility and freedom to grow at your own pace.",
    },
    {
      icon: IoReceiptOutline,
      title: "GST-Ready Billing",
      content:
        "Get fully compliant, GST-ready invoice with transparent breakdowns, making it easy to claim input credits and simplify tax filing.",
    },
    {
      icon: LuSlack,
      title: "99.99% SLA",
      content:
        "Experience high availability and guaranteed uptime, backed by a 99.99% Service Level Agreement (SLA).",
    },
    {
      icon: MdScale,
      title: "Economy of Scale",
      content:
        "Scale efficiently with enterprise-grade cloud solutions at affordable rates, maximizing performance while reducing costs.",
    },
  ],
};
